import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="floating-whatsapp-btn"
    href="https://wa.me/918079090643?text=Hello%20Majisa%20Man%20Power%20Service%2C%20I%20need%20manpower%20for%20my%20business.%20Please%20share%20details."
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    className="whatsapp-pulse fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-2xl"
  >
    <MessageCircle className="w-7 h-7 text-white fill-white" />
  </motion.a>
);
